var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      ref: "menu",
      attrs: {
        "close-on-content-click": false,
        "return-value": _vm.date,
        lazy: "",
        transition: "scale-transition",
        disabled: _vm.disabled,
        "offset-y": "",
        "nudge-bottom": _vm.nudgeBottom,
        "nudge-right": _vm.nudgeRight
      },
      on: {
        "update:returnValue": function($event) {
          _vm.date = $event
        },
        "update:return-value": function($event) {
          _vm.date = $event
        }
      },
      model: {
        value: _vm.menu,
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    },
    [
      _vm._t("default", null, { slot: "activator" }),
      _vm._v(" "),
      _c(
        "v-date-picker",
        {
          attrs: {
            "no-title": "",
            min: _vm.minDate,
            max: _vm.maxDate,
            "show-current": !_vm.showSelectedDate,
            "allowed-dates": _vm.allowedDates
          },
          model: {
            value: _vm.date,
            callback: function($$v) {
              _vm.date = $$v
            },
            expression: "date"
          }
        },
        [
          _c("v-spacer"),
          _vm._v(" "),
          _vm.clearable
            ? _c(
                "v-btn",
                {
                  attrs: { flat: "", color: "error" },
                  on: {
                    click: function($event) {
                      return _vm.updateValue(undefined)
                    }
                  }
                },
                [_vm._v("\n      Clear\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { flat: "", color: "primary" },
              on: { click: _vm.closeMenu }
            },
            [_vm._v(" Cancel ")]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { flat: "", color: "primary" },
              on: {
                click: function($event) {
                  return _vm.updateValue(_vm.date)
                }
              }
            },
            [_vm._v(" OK ")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }